/** The double-submit CSRF pair: the backend sets the cookie, mutating calls echo it in a header. */
export const CSRF_COOKIE = 'tt_csrf';
export const CSRF_HEADER = 'x-csrf';

/** A cookie's value by exact name, or null. */
export function readCookie(name: string, cookies: string = document.cookie): string | null {
  for (const part of cookies.split(';')) {
    const eq = part.indexOf('=');
    if (eq !== -1 && part.slice(0, eq).trim() === name) {
      return decodeURIComponent(part.slice(eq + 1).trim());
    }
  }
  return null;
}

/**
 * Expire a cookie readable by script. `tt_access` and `tt_refresh` are httpOnly — only
 * `/auth/logout` can clear those — so this only ever reaches `tt_csrf`.
 */
export function expireCookie(name: string): void {
  document.cookie = `${name}=; Max-Age=0; path=/`;
}
